module.exports = __webpack_public_path__ + "media/images/icons/truck-on-grey-961918f3cfb0b5c03221c97df9a84f5f.png";